import { createFileRoute } from "@tanstack/react-router";
import CountyPermitsPage from "@/features/public/pages/tools/county-permits";

export const Route = createFileRoute("/(public)/_public/tools/county-permits")({
  component: CountyPermitsPage,
});
